<script>
/** Components */
import FormVisualElement from '@/components/FormVisualElement'
import { ValidationObserver } from 'vee-validate'

export default {
  components: {
    FormVisualElement,
    ValidationObserver,
  },

  defaultContent: {},

  props: {
    podcastId: {
      type: String,
      default: '',
    },

    _id: {
      type: String,
      default: '',
    },

    time: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },

    content: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      modelDataElement: {
        ...this.$options.defaultContent,
        ...this.content,
      },
      disableWatch: false,
    }
  },

  watch: {
    modelDataElement: {
      deep: true,
      handler() {
        if (!this.disableWatch) {
          this.$emit('update', {
            _id: this._id,
            type: this.type,
            time: this.time,
            label: this.label,
            content: {
              ...Object.keys(this.modelDataElement).reduce((newObj, key) => {
                if (key !== '__typename') {
                  // this.modelDataElement[key] !== null
                  newObj[key] = this.modelDataElement[key]
                }
                return newObj
              }, {}),
            },
          })
        }
      },
    },
  },
}
</script>
